module.exports = __webpack_public_path__ + "static/media/dryer-alt.cca309d1.svg";